import React from 'react';

import { Box, H3, Link, Separator, Text } from '@betterment/samba-react';

import { ClientAgreements } from '../FirmTermsAcceptance/data';

interface Props {
  firmName: string;
  agreements: ClientAgreements;
}

const AdvisoryAgreements: React.FC<React.PropsWithChildren<Props>> = ({ firmName, agreements }) => {
  return (
    <Box
      css={{
        my: 'space.300',
        border: 'solid 1px',
        borderColor: 'border',
        borderRadius: 'medium',
        padding: 'space.200',
      }}
    >
      <H3 variant="title100">Advisory agreements</H3>
      <Separator css={{ my: 'space.150' }} />
      <Box>
        <ul style={{ marginBottom: 0 }}>
          {agreements.clientAgreement && (
            <li>
              <Text>
                {firmName}&apos;s{' '}
                <Link target="_blank" href={agreements.clientAgreement.url} rel="noopener noreferrer">
                  agreement and disclosure materials
                </Link>
                , prepared by {firmName} and which may included {firmName}&apos;s advisory agreement, Form ADV Part 2A,
                Form CRS and/or privacy policy, as applicable. (Copies of these agreements are also available from{' '}
                {firmName}).
              </Text>
            </li>
          )}
          <li>
            <Text>
              Your advisory agreement with {firmName} is an agreement solely between you and your advisor, and
              Betterment and its affiliates are not by any means acquiring any obligation or legal duties by permitting
              it to be executed here. You understand that Betterment has not reviewed the advisory agreement between you
              and your advisor and is not responsible for your advisor meeting the terms of that agreement.
            </Text>
          </li>
          <li>
            <Text>
              You are able to receive and view the linked documents in electronic form via this webpage and consent to
              doing so. You understand that checking the above box and clicking "Agree and continue" below is the legal
              equivalent of signing by hand and agree to be legally bound by the linked documents.
            </Text>
          </li>
        </ul>
      </Box>
    </Box>
  );
};

export default AdvisoryAgreements;
